import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_input = _resolveComponent("el-input");

  return _openBlock(), _createBlock(_component_el_input, {
    class: "input-with-select",
    size: "large",
    placeholder: _ctx.placeholder,
    clearable: "",
    modelValue: _ctx.searchValue,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.searchValue = $event;
    }),
    onInput: _ctx.onSearchChange,
    "data-test": "search-filter-input"
  }, null, 8, ["placeholder", "modelValue", "onInput"]);
}